import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Flex, Heading, useToast, Button, Modal } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import GModal from "components/ui/modal/Modal";
import GButton from "components/ui/button/Button";
import routes from "navigations/routes";
import { useNavigate } from "react-router-dom";
import { getTransfersList, rejectedRecieveTransfers } from "../services/transfersServices";


export default function RecjectTransfer({ onClose, id}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const toast = useToast({ position: "top", duration: 3000, status: "success", });

  return <>
    <>
      <GModal
        modalHeader={t("pages.transfers.reject")}
        onClose={onClose}
        modalContent={
          <Box p={6}>
            <Heading
              as="h4"
              fontSize="1.3rem"
              mb={6}
              textTransform="capitalize"
            >
              {t("pages.transfers.reject_text")}
            </Heading>
            <Flex gap={4}>
              <GButton
                title={t("general.yes")}
                bg="red.600"
                border="1px solid transparent"
                color="light"
                hover={{ color: "red.600", borderColor: "red.600", bg: "none" }}
                onClick={(_) => {
                  dispatch(rejectedRecieveTransfers({TransfersId:id.TransfersId , Status:0}))
                    .unwrap()
                    .then((_) => {
                      toast({description: t("pages.transfers.Item_Rejected")});
                      dispatch(getTransfersList());
                      navigate(`/${routes.inventory_transfers}`);
                      onClose();
                    });
                }}
              />
              <GButton
                title={t("general.cancel")}
                bg="none"
                color="dark"
                border="1px solid"
                borderColor="border"
                hover={{ color: "red.600", borderColor: "red.600", bg: "none" }}
                onClick={onClose}
              />
            </Flex>
          </Box>
        }
      />
    </>
</>;
};